export const removeEscapeCharForNewLine = (str: string): string => {
  try {
    return str?.replace(/\\n/g, "");
  } catch {
    return "";
  }
};
